export enum CommunityMediaEnum {
    image = 'image',
    audio = 'audio',
    video = 'video',
    document = 'document',
    link = 'link',
}